// src/jira/issue/types.ts
var JiraIssueAriResourceOwner = "jira", JiraIssueAriResourceType = "issue";

export {
  JiraIssueAriResourceOwner,
  JiraIssueAriResourceType
};
